interface IRequestParams {
  psaId: number;
  ticketId?: string;
  contactId?: string;
}

export const getRequestKey = ({ psaId, ticketId, contactId }: IRequestParams): string =>
  `${psaId}-${contactId ?? ticketId ?? ''}`;
